import { COLUMN_ACCESS, COLUMN_AREA, COLUMN_DEPARTMENT, COLUMN_END_TIME, COLUMN_FRI, COLUMN_HOL, COLUMN_MAX_CAPACITY, COLUMN_MON, COLUMN_NAME, COLUMN_SAT, COLUMN_SITE, COLUMN_START_TIME, COLUMN_SUN, COLUMN_THU, COLUMN_TIME_PATTERN, COLUMN_TUE, COLUMN_WED } from "../../constants/column-types";
import { FILTER_ACCESS_GROUP, FILTER_ACCESS_TIME_PATTERN, FILTER_AREA, FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const AccessGroupReportColumn : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "agName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Access Area",
        accessor: "accessArea",
        isNumeric: false,
        id: 1,
        sortByName: "area.areaName",
        sortDirection: "asc",
        active: true,
        searchOnName: "area.id",
        lookupName: "area.areaName",
        translationKey: "accessArea",
        columnId: COLUMN_AREA,
        filterId: FILTER_AREA,
        settingDataName: "area"
    },
    {
        heading: "Access Time Patterns",
        accessor: "accessTimePattern",
        isNumeric: false,
        id: 2,
        sortByName: "accessTimePattern.atpName",
        sortDirection: "asc",
        active: true,
        lookupName: "accessTimePattern.atpName",
        searchOnName: "accessTimePattern.id",
        translationKey: "accessTimePattern",
        columnId: COLUMN_TIME_PATTERN,
        filterId: FILTER_ACCESS_TIME_PATTERN,
        settingDataName: 'accessTimePattern'
    },
    {
        heading: "Group Type",
        accessor: "groupType",
        isNumeric: true,
        id: 16,
        active: true,
        lookupName: "agType",
        searchOnName: "agType",
        translationKey: "groupType",
        settingDataName: 'groupType'
    },
    {
        heading: "Start Time",
        accessor: "startTime",
        isNumeric: false,
        id: 3,
        active: true,
       // sortDirection: "asc",
       // sortByName: "accessTimePattern.atpStartTime",
        translationKey: "startTime",
        columnId: COLUMN_START_TIME,
    },
    {
        heading: "End Time",
        accessor: "endTime",
        isNumeric: false,
        id: 4,
        active: true,
       // sortDirection: "asc",
      //  sortByName: "accessTimePattern.atpEndTime",
        translationKey: "endTime",
        columnId: COLUMN_END_TIME,
    },
    {
        heading: "Monday",
        accessor: "monday",
        isNumeric: false,
        id: 5,
        active: true,
        translationKey: "mon",
        columnId: COLUMN_MON,
    },
    {
        heading: "Tuesday",
        accessor: "tuesday",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "tue",
        columnId: COLUMN_TUE,
    },
    {
        heading: "Wednesday",
        accessor: "wednesday",
        isNumeric: false,
        id: 7,
        active: true,
        translationKey: "wed",
        columnId: COLUMN_WED,
    },
    {
        heading: "Thursday",
        accessor: "thursday",
        isNumeric: false,
        id: 8,
        active: true,
        translationKey: "thu",
        columnId: COLUMN_THU,
    },
    {
        heading: "Friday",
        accessor: "friday",
        isNumeric: false,
        id: 9,
        active: true,
        translationKey: "fri",
        columnId: COLUMN_FRI,
    },
    {
        heading: "Saturday",
        accessor: "saturday",
        isNumeric: false,
        id: 10,
        active: true,
        translationKey: "sat",
        columnId: COLUMN_SAT,
    },
    {
        heading: "Sunday",
        accessor: "sunday",
        isNumeric: false,
        id: 11,
        active: true,
        translationKey: "sun",
        columnId: COLUMN_SUN,
    },
    {
        heading: "Holiday",
        accessor: "holiday",
        isNumeric: false,
        id: 12,
        active: true,
        translationKey: "hol",
        columnId: COLUMN_HOL,
    },
    {
        heading: "Max Capacity",
        accessor: "maxCapacity",
        isNumeric: false,
        id: 13,
        active: false,
        translationKey: "maxCapacity",
        sortByName: "agMaxCapacity",
        sortDirection: "asc",
        columnId: COLUMN_MAX_CAPACITY,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 14,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    },
];

export default AccessGroupReportColumn;
